import { render, staticRenderFns } from "./PhysicalAssessmentAction.vue?vue&type=template&id=cf867876&scoped=true&"
import script from "./PhysicalAssessmentAction.vue?vue&type=script&lang=js&"
export * from "./PhysicalAssessmentAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf867876",
  null
  
)

export default component.exports